// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.GetLandlordPaymentSettingsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetLandlordPaymentSettingsWebApiRequestDto, GetLandlordPaymentSettingsWebApiResponseDto } from '../..';

export const GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings_Path =
  '/api/web/v1/getLandlordPaymentSettings';

/**
 * Get landlord payment settings
 */
export const GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings = (
  postData: GetLandlordPaymentSettingsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    GetLandlordPaymentSettingsWebApiRequestDto,
    GetLandlordPaymentSettingsWebApiResponseDto
  >(
    {
      endpoint: GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
